export const REGIONS = ['Africa', 'Americas', 'Asia', 'Europe', 'Oceania'];
